// @ts-nocheck
import { useEffect, useRef, useState, Ref, useMemo, useCallback } from "react";
import { useNavigationStore } from "src/store/navigationStore";

import { Canvas, useFrame, RootState } from "@react-three/fiber";
import { Splat, useGLTF, useAnimations } from "@react-three/drei";
import * as THREE from "three";
import { Group } from "three";

import { useModelViewerStore } from "@/store/modelViewerStore";

import {
  createRadialScript,
  SplatLodComponent,
  SplatSogComponent,
  RobotAvatar,
} from "@/components/playcanvas/playcanvasComponents";

import {
  roundToDecimals,
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  angleDifferenceABtoAC,
  wrapAngle,
  calculateTargetPosition,
  normalizeRotation,
} from "src/utils/game";
import * as pc from "playcanvas";
import { OrbitControls } from "@playcanvas/react/scripts";
import {
  useTexture,
  useMaterial,
  useEnvAtlas,
  useApp,
  useSplat,
  useModel,
  useAppEvent,
} from "@playcanvas/react/hooks";
import { Application, Entity, Gltf } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  GSplat,
  Script,
  Environment,
} from "@playcanvas/react/components";
import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";

import WatermarkScreen from "src/components/watermark";
import { useLodSplat } from "src/utils/useLodSplat";
import LottieLoading from "src/components/lottie/lottie-loading";

import { GsplatRevealRadial } from "src/extra_js/reveal-radial.mjs";

export default function ModelViewerWithCustomPath() {
  const interruptAutoPlay = useModelViewerStore(
    (state) => state.interruptAutoPlay,
  );
  const setProgress = useModelViewerStore((state) => state.setProgress);

  const setCameraPosition = useModelViewerStore(
    (state) => state.setCameraPosition,
  );
  const setCameraLookingPosition = useModelViewerStore(
    (state) => state.setCameraLookingPosition,
  );
  const setCameraAngle = useModelViewerStore((state) => state.setCameraAngle);

  const setIsModelLoaded = useModelViewerStore(
    (state) => state.setIsModelLoaded,
  );
  const setErrorMessage = useModelViewerStore((state) => state.setErrorMessage);

  // const moveSpeedRef = useRef<number>(2);
  const moveSpeedRef = useRef<number>(0.5);
  const rotateSpeedRef = useRef<number>(20);

  const defaultPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const defaultTargetRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, -1));

  const targetAltitudeRef = useRef<number>(0);

  const latestCurrentLevelNameRef = useRef<string>("");

  const mainObjectEntityRef = useRef();
  const cameraScriptRef = useRef();
  const hiddenNearRef = useRef<pc.Entity>(null);
  const hiddenFarRef = useRef<pc.Entity>(null);
  const firstPersonCameraEntityRef = useRef();
  const thirdPersonCameraEntityRef = useRef();
  const latestCameraModeRef = useRef<number>(0);

  const transitionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const eulerRef = useRef(new pc.Vec3(0, 0, 0));

  const isMovingRef = useRef<boolean>(false);
  const isRotatingRef = useRef<boolean>(false);

  const latestPositionJoystickData = useRef<number[]>([0, 0]);
  const latestRotationJoystickData = useRef<number[]>([0, 0]);
  const latestRotationScreenData = useRef<number[]>([0, 0]);

  const latestResetPositionRotationEvent = useRef<number>(0);
  const latestResetOnlyRotationEvent = useRef<number>(0);

  const latestVenueModelConfigRef = useRef<VenueModelConfig | null>(null);

  const isInstantUpdate = useRef<boolean>(false);

  const latestModelJsonData = useRef<any>(null);
  const latestCustomPathJsonData = useRef<any>(null);

  const pathPosition = useRef<number[][]>([
    [0, 0, 0],
    [0, 0, 0],
  ]);

  const pathRotation = useRef<number[][]>([
    [0, 0, 0],
    [0, 0, 0],
  ]);

  const latestProgressRef = useRef(0);

  const isDisplayAvatarRef = useRef<boolean>(false);

  const AUTOPLAY_SPEED = 4;
  const autoPlaySpeedRef = useRef<number>(AUTOPLAY_SPEED);
  const isAutoPlayingRef = useRef<boolean>(false);
  const autoPlayTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const gsplatAllRef = useRef({});

  const splatFormat = useRef("");

  function stopAutoPlay() {
    isAutoPlayingRef.current = false;
    if (autoPlayTimeoutRef.current) {
      clearTimeout(autoPlayTimeoutRef.current);
      autoPlayTimeoutRef.current = null;
    }
  }
  function resumeAutoPlay(milliseconds: number) {
    if (milliseconds > 0) {
      stopAutoPlay();
    }
    autoPlayTimeoutRef.current = setTimeout(() => {
      autoPlayTimeoutRef.current = null;
      isAutoPlayingRef.current = true;
    }, milliseconds);
  }

  function interpolateVector3Array(points, percentage) {
    if (percentage <= 0) return points[0];
    if (percentage >= 1) return points[points.length - 1];

    const segments = points.length - 1;
    const scaledPosition = percentage * segments;
    const segmentIndex = Math.floor(scaledPosition);
    const segmentFraction = scaledPosition - segmentIndex;

    const start = points[segmentIndex];
    const end = points[segmentIndex + 1];

    return [
      start[0] + (end[0] - start[0]) * segmentFraction,
      start[1] + (end[1] - start[1]) * segmentFraction,
      start[2] + (end[2] - start[2]) * segmentFraction,
    ];
  }

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key.toLowerCase() === "p") {
        if (mainObjectEntityRef.current) {
          console.log("position :");
          const position = mainObjectEntityRef.current.getPosition();
          const rotation = mainObjectEntityRef.current.getLocalEulerAngles();
          console.log(
            "[" +
              position.x.toFixed(2) +
              "," +
              position.y.toFixed(2) +
              "," +
              position.z.toFixed(2) +
              "],",
          );
          console.log("rotation :");
          if ((rotation.z = 180)) {
            console.log(
              "[" +
                0 +
                "," +
                (rotation.y * -1 + 180).toFixed(2) +
                "," +
                0 +
                "],",
            );
          } else {
            console.log("[" + 0 + "," + rotation.y.toFixed(2) + "," + 0 + "],");
          }
          // console.log(
          //   "[" +
          //     rotation.x.toFixed(2) +
          //     "," +
          //     rotation.y.toFixed(2) +
          //     "," +
          //     rotation.z.toFixed(2) +
          //     "],",
          // );

          // mainObjectEntityRef.current.setPosition(1.6011,0.1116,-3.2228);
          // mainObjectEntityRef.current.setLocalEulerAngles(5.9660,35.0880,-0.0000);
          // isMovingRef.current = true;
          // isRotatingRef.current = true;
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    setIsModelLoaded(false);
    setErrorMessage("");
  }, []);

  function useQueryParams() {
    return useMemo(() => new URLSearchParams(window.location.search), []);
  }

  const DataController = () => {
    const resetPositionRotationEvent = useModelViewerStore(
      (state) => state.resetPositionRotationEvent,
    );
    useEffect(() => {
      latestResetPositionRotationEvent.current = resetPositionRotationEvent;
    }, [resetPositionRotationEvent]);

    const resetOnlyRotationEvent = useModelViewerStore(
      (state) => state.resetOnlyRotationEvent,
    );
    useEffect(() => {
      latestResetOnlyRotationEvent.current = resetOnlyRotationEvent;
    }, [resetOnlyRotationEvent]);

    const positionJoystickData = useModelViewerStore(
      (state) => state.positionJoystickData,
    );
    const rotationJoystickData = useModelViewerStore(
      (state) => state.rotationJoystickData,
    );

    useEffect(() => {
      latestPositionJoystickData.current = [
        positionJoystickData[0],
        positionJoystickData[1],
      ];
    }, [positionJoystickData]);

    useEffect(() => {
      latestRotationJoystickData.current = [
        rotationJoystickData[0],
        rotationJoystickData[1],
      ];
    }, [rotationJoystickData]);

    const progress = useModelViewerStore((state) => state.progress);

    useEffect(() => {
      latestProgressRef.current = progress;
      const newPosition = interpolateVector3Array(
        pathPosition.current,
        progress,
      );
      const newRotation = interpolateVector3Array(
        pathRotation.current,
        progress,
      );

      if (mainObjectEntityRef.current) {
        mainObjectEntityRef.current.setPosition(
          newPosition[0],
          newPosition[1],
          newPosition[2],
        );
        mainObjectEntityRef.current.setLocalEulerAngles(
          newRotation[0],
          newRotation[1],
          newRotation[2],
        );
        isMovingRef.current = true;
        isRotatingRef.current = true;
      }

      eulerRef.current.x = newRotation[0];
      eulerRef.current.y = newRotation[1];
      eulerRef.current.z = newRotation[2];

      updateCameraData();
      // setCameraAngle(newRotation[1]);
    }, [progress]);

    const interruptAutoPlayEvent = useModelViewerStore(
      (state) => state.interruptAutoPlayEvent,
    );
    useEffect(() => {
      if (interruptAutoPlayEvent != -1) {
        //resumeAutoPlay(2000);
      }
    }, [interruptAutoPlayEvent]);

    const cameraMode = useModelViewerStore((state) => state.cameraMode);
    useEffect(() => {
      latestCameraModeRef.current = cameraMode;
    }, [cameraMode]);

    return <></>;
  };

  const updateCameraData = () => {
    if (mainObjectEntityRef.current) {
      const cameraPosition = mainObjectEntityRef.current.getPosition();
      setCameraPosition(cameraPosition);
      const cameraAngle = getYAngleDegree(
        firstPersonCameraEntityRef.current.getPosition(),
        mainObjectEntityRef.current.getPosition(),
      );
      setCameraAngle(cameraAngle);
    }
  };

  const cleanup = (app, gsplatEntity) => {
    const cleanup = installCameraNearFar(app, gsplatEntity);
    return cleanup;
  };

  const installCameraNearFar = (
    app: pc.Application,
    gsplatEntity: pc.Entity,
  ) => {
    const device = app.graphicsDevice;
    const gsplatMat =
      app.scene.gsplat.material || gsplatEntity.gsplat?.material;
    if (!gsplatMat) return () => {};

    if (!hiddenNearRef.current || !hiddenFarRef.current) {
      return () => {};
    }
    const glsl = `
      uniform vec3 uCutA;       // camera position in WORLD space
      uniform vec3 uCutB;       // robot position in WORLD space
      uniform float uCutRadius; // cylinder radius of the cutaway
      uniform float uCutFeather;// soft edge transition distance

      // Calculate the shortest distance from a point (p) to a line segment (a to b)
      float segDist(vec3 p, vec3 a, vec3 b) {
        vec3 pa = p - a;
        vec3 ba = b - a;
        float h = clamp(dot(pa, ba) / max(dot(ba, ba), 1e-6), 0.0, 1.0);
        return length(pa - ba * h);
      }

      void modifySplatCenter(inout vec3 center) {
      }

      void modifySplatRotationScale(vec3 originalCenter, vec3 modifiedCenter, inout vec4 rotation, inout vec3 scale) {
        // Calculate distance between current splat and the Camera-Robot line segment
        float d = segDist(originalCenter, uCutA, uCutB);
        float alpha = smoothstep(uCutRadius, uCutRadius + uCutFeather, d);

        // Scale down splats that are too close to the line to 0, making them disappear
        scale *= alpha;
      }

      void modifySplatColor(vec3 center, inout vec4 color) {
        // Apply the same transition to the alpha channel as a double-safeguard
        float d = segDist(center, uCutA, uCutB);
        float alpha = smoothstep(uCutRadius, uCutRadius + uCutFeather, d);
        color.a *= alpha;
      }
    `;

    gsplatMat.getShaderChunks("glsl").set("gsplatModifyVS", glsl);
    gsplatMat.update();
    const uCutA = device.scope.resolve("uCutA");
    const uCutB = device.scope.resolve("uCutB");
    const uCutRadius = device.scope.resolve("uCutRadius");
    const uCutFeather = device.scope.resolve("uCutFeather");
    uCutRadius.setValue(1);
    uCutFeather.setValue(0.01);
    const onUpdate = () => {
      if (!hiddenNearRef.current || !hiddenFarRef.current) {
        return;
      }
      const nearPosition = hiddenNearRef.current.getPosition().clone();
      const farPosition = hiddenFarRef.current.getPosition().clone();
      if (nearPosition.length() === 0 || isNaN(nearPosition.x)) return;
      const dirToCamera = new pc.Vec3().sub2(nearPosition, farPosition);
      const totalDist = dirToCamera.length();
      dirToCamera.normalize();
      uCutA.setValue([nearPosition.x, nearPosition.y, nearPosition.z]);
      uCutB.setValue([farPosition.x, farPosition.y, farPosition.z]);
    };

    app.on("update", onUpdate);
    return () => app.off("update", onUpdate);
  };

  const MainCamera = () => {
    const app = useApp();
    const cameraRef = useRef();
    let _localProgress;
    let _localCameraMode;
    let isCameraModeUpdated;
    let nearestFixedCameraPosition;

    let finalCameraPosition;
    let finalCameraLookingPosition;

    app.on("update", function (dt) {
      if (cameraScriptRef.current == null) {
        return;
      }

      isCameraModeUpdated = _localCameraMode != latestCameraModeRef.current;
      _localCameraMode = latestCameraModeRef.current;

      if (
        isInstantUpdate.current ||
        isCameraModeUpdated ||
        isMovingRef.current ||
        isRotatingRef.current
      ) {
        const newPosition =
          latestCameraModeRef.current == 0
            ? firstPersonCameraEntityRef.current.getPosition()
            : thirdPersonCameraEntityRef.current.getPosition();
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPosition,
        );

        isMovingRef.current = false;
        isRotatingRef.current = false;
        isInstantUpdate.current = false;
      }
    });

    useEffect(() => {
      const defaultCameraLookingPosition = new pc.Vec3(0, 0, 0);
      const defaultPosition = new pc.Vec3(0, 0, 0);
      cameraScriptRef.current.reset(
        defaultCameraLookingPosition,
        defaultPosition,
      );
    }, []);

    app.on("update", function (dt) {
      if (cameraScriptRef.current == null) {
        return;
      }
    });

    return (
      <Entity>
        <Camera fov={60} />
        <Script
          ref={cameraScriptRef}
          script={CameraControls}
          enableFly={false}
        />
        <Entity ref={hiddenNearRef} position={[0, 0, 0]}></Entity>
        <Entity ref={hiddenFarRef} position={[0, 0, -0.5]}></Entity>
      </Entity>
    );
  };

  // const Avatar = () => {
  //   const app = useApp();
  //   const avatarEntityRef = useRef();
  //   let floatTime = 0;
  //   const _avatarPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  //   const { asset: robot } = useModel(GLB_AVATAR);
  //   const changeMaterial = (entity) => {
  //     if (entity == null) {
  //       return;
  //     }
  //     const renders = entity.findComponents("render");
  //     renders.forEach((render) => {
  //       if (render.meshInstances) {
  //         render.meshInstances.forEach((meshInstance) => {
  //           const material = meshInstance.material;
  //           if (material) {
  //             material.emissiveMap = material.diffuseMap;
  //             material.emissiveIntensity = 1.0;
  //             material.emissive = new pc.Color(1, 1, 1);
  //             material.useLighting = false;
  //             material.update();
  //           }
  //         });
  //       }
  //     });
  //   };

  //   useEffect(() => {
  //     if (robot && avatarEntityRef.current) {
  //       requestAnimationFrame(() => {
  //         changeMaterial(avatarEntityRef.current);
  //       });
  //     }
  //   }, [robot]);

  //   const handleUpdate = useCallback((dt: number) => {
  //     floatTime += dt;
  //     if (avatarEntityRef.current) {
  //       _avatarPositionRef.current.set(0, Math.sin(floatTime * 2) * 0.05, 0);
  //       avatarEntityRef.current.setLocalPosition(_avatarPositionRef.current);
  //       avatarEntityRef.current.enabled =
  //         latestCameraModeRef.current == 1 || isDisplayAvatarRef.current;
  //     }
  //   }, []);
  //   useAppEvent("update", handleUpdate);

  //   return robot ? (
  //     <Entity position={[0, -1, 0]}>
  //       <Entity
  //         ref={avatarEntityRef}
  //         rotation={[10, 180, 0]}
  //         position={[0, 0, 0]}
  //         scale={[1, 1, 1]}
  //       >
  //         <Render type="asset" asset={robot} />
  //       </Entity>
  //     </Entity>
  //   ) : (
  //     <></>
  //   );
  // };

  const MainObject = () => {
    const queryParams = useQueryParams();
    const modelLink = queryParams.get("model");
    const app = useApp();

    const defaultPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
    const defaultTargetRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, -1));

    let goDownAnimationTime = 0;
    const goDownDuration = 3;

    let goUpAnimationTime = 0;
    const goUpDuration = 2;

    let _localResetPositionRotationEvent = 0;
    let _localResetOnlyRotationEvent = 0;
    let _localLeaveVenueEvent = 0;
    let temp = false;

    let tempY;
    let tempX;
    let tempZ;

    let isInit;
    let processingX;
    let processingY;
    let processingZ;

    useEffect(() => {
      if (latestCustomPathJsonData.current == null) {
        if (!modelLink) {
          return;
        }
        let pathJsonLink;
        if (splatFormat.current == "sog") {
          pathJsonLink = modelLink.replace(".sog", "_customPath.json");
        } else if (splatFormat.current == "_lod") {
          pathJsonLink = modelLink + "customPath.json";
        }
        if (pathJsonLink) {
          fetchCustomPathData(pathJsonLink);
        }
      } else {
        if (
          latestCustomPathJsonData.current.position &&
          latestCustomPathJsonData.current.rotation
        ) {
          setPositionEulerAngles(
            latestCustomPathJsonData.current.position[0][0],
            latestCustomPathJsonData.current.position[0][1],
            latestCustomPathJsonData.current.position[0][2],
            latestCustomPathJsonData.current.rotation[0][0],
            latestCustomPathJsonData.current.rotation[0][1],
            latestCustomPathJsonData.current.rotation[0][2],
          );
        }
      }
    }, []);

    const setInitPositionTarget = (
      positionX: number,
      positionY: number,
      positionZ: number,
      targetX: number,
      targetY: number,
      targetZ: number,
    ) => {
      defaultPositionRef.current.set(-positionX, positionY, -positionZ);
      defaultTargetRef.current.set(-targetX, positionY, -targetZ);
      mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
      mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
      const initAngles = mainObjectEntityRef.current.getEulerAngles();
      if (initAngles.z < 90 && initAngles.z > -90) {
        console.log("type A");
        eulerRef.current.set(initAngles.x, initAngles.y, 0);
      } else if (initAngles.z > 90 || initAngles.z < -90) {
        console.log("type B");
        eulerRef.current.set(initAngles.x - 180, 180 - initAngles.y, 0);
      } else {
        console.log("type C");
        eulerRef.current.set(0, 0, 0);
      }
      isInstantUpdate.current = true;
    };
    const setInitPositionAngle = (
      tx: number,
      ty: number,
      tz: number,
      qx: number,
      qy: number,
      qz: number,
      qw: number,
    ) => {
      defaultPositionRef.current.set(-tx, -ty, -tz);
      const target = calculateTargetPosition(-tx, -ty, -tz, -qx, qy, qz, qw);
      defaultTargetRef.current.set(target.x, target.y, target.z);
      mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
      mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
      const initAngles = mainObjectEntityRef.current.getEulerAngles();
      if (initAngles.z < 90 && initAngles.z > -90) {
        console.log("type A");
        eulerRef.current.set(initAngles.x, initAngles.y, 0);
      } else if (initAngles.z > 90 || initAngles.z < -90) {
        console.log("type B");
        eulerRef.current.set(initAngles.x - 180, 180 - initAngles.y, 0);
      } else {
        console.log("type C");
        eulerRef.current.set(0, 0, 0);
      }
      isInstantUpdate.current = true;
    };
    app.on("update", function (dt) {
      if (mainObjectEntityRef.current == null) {
        return;
      }
      let isResetPositionRotation =
        _localResetPositionRotationEvent !=
        latestResetPositionRotationEvent.current;
      _localResetPositionRotationEvent =
        latestResetPositionRotationEvent.current;

      let isResetOnlyRotation =
        _localResetOnlyRotationEvent != latestResetOnlyRotationEvent.current;
      _localResetOnlyRotationEvent = latestResetOnlyRotationEvent.current;

      if (latestPositionJoystickData.current.length != 2) {
        return;
      }
      if (
        latestPositionJoystickData.current[0] != 0 ||
        latestPositionJoystickData.current[1] != 0
      ) {
        isMovingRef.current = true;
        const worldMat = mainObjectEntityRef.current.getWorldTransform();
        const forward = new pc.Vec3(0, 0, -1);
        worldMat.transformVector(forward, forward);
        forward.normalize();
        const up = pc.Vec3.UP.clone();
        const right = new pc.Vec3();
        right.cross(up, forward).normalize();
        const forwardScale =
          latestPositionJoystickData.current[1] * moveSpeedRef.current * -dt;
        const rightScale =
          latestPositionJoystickData.current[0] * moveSpeedRef.current * -dt;
        const forwardMove = forward.clone().mulScalar(forwardScale);
        const rightMove = right.clone().mulScalar(rightScale);
        const move = new pc.Vec3();
        move.add(forwardMove).add(rightMove);
        mainObjectEntityRef.current.translate(move);
      }
      if (
        latestRotationJoystickData.current[0] != 0 ||
        latestRotationJoystickData.current[1] != 0
      ) {
        isRotatingRef.current = true;

        eulerRef.current.y +=
          -latestRotationJoystickData.current[0] * rotateSpeedRef.current * dt; // Yaw
        eulerRef.current.x +=
          -latestRotationJoystickData.current[1] * rotateSpeedRef.current * dt; // Pitch

        eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
        eulerRef.current.y = wrapAngle(eulerRef.current.y);
        mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
      }
      if (
        latestRotationScreenData.current[0] != 0 ||
        latestRotationScreenData.current[1] != 0
      ) {
        isRotatingRef.current = true;
        eulerRef.current.y +=
          -latestRotationScreenData.current[0] * rotateSpeedRef.current * dt; // Yaw
        eulerRef.current.x +=
          -latestRotationScreenData.current[1] * rotateSpeedRef.current * dt; // Pitch

        eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
        eulerRef.current.y = wrapAngle(eulerRef.current.y);
        mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
      }
    });
    return (
      <Entity ref={mainObjectEntityRef}>
        <RobotAvatar />
        <Entity
          ref={firstPersonCameraEntityRef}
          position={[0, 0, 0.001]}
        ></Entity>
        <Entity
          ref={thirdPersonCameraEntityRef}
          position={[0, 0.5, 4]}
        ></Entity>
      </Entity>
    );
  };

  const SingleLod = () => {
    const app = useApp();
    const queryParams = useQueryParams();
    const modelLink = queryParams.get("model");
    const lodLink = modelLink + "/lod/lod-meta.json";
    const pathJsonLink = modelLink + "/customPath.json";
    const callbackReadyFunction = (splat) => {
      console.log("single lod ready");
      console.log(splat);
      setTimeout(() => {
        splat.gsplat.enabled = true;
        createRadialScript(mainObjectEntityRef.current, splat);
        setIsModelLoaded(true);
      }, 200);
      setTimeout(() => {
        cleanup(app, splat);
      }, 4000);
      if (latestCustomPathJsonData.current == null) {
        if (!pathJsonLink) {
          return;
        }
        fetchCustomPathData(pathJsonLink);
      } else {
        if (
          latestCustomPathJsonData.current.position &&
          latestCustomPathJsonData.current.rotation
        ) {
          setPositionEulerAngles(
            latestCustomPathJsonData.current.position[0][0],
            latestCustomPathJsonData.current.position[0][1],
            latestCustomPathJsonData.current.position[0][2],
            latestCustomPathJsonData.current.rotation[0][0],
            latestCustomPathJsonData.current.rotation[0][1],
            latestCustomPathJsonData.current.rotation[0][2],
          );
        }
      }
    };
    return (
      <SplatLodComponent
        app={app}
        url={lodLink}
        position={[0, 0, 0]}
        rotation={[180, 0, 0]}
        scale={[1, 1, 1]}
        callbackReady={callbackReadyFunction}
      />
    );
  };

  

  const SingleSog = () => {
    const app = useApp();
    const queryParams = useQueryParams();
    const modelLink = queryParams.get("model");
    const pathJsonLink = modelLink.replace(".sog", "_customPath.json");
    const callbackReadyFunction = (splat) => {
      console.log("single sog ready");
      setTimeout(() => {
        splat.gsplat.enabled = true;
        createRadialScript(mainObjectEntityRef.current, splat);
        setIsModelLoaded(true);
      }, 200);
      setTimeout(() => {
        cleanup(app, splat);
      }, 4000);

    };

    return (
      <SplatSogComponent
        app={app}
        url={modelLink}
        position={[0, 0, 0]}
        rotation={[180, 0, 0]}
        scale={[1, 1, 1]}
        callbackReady={callbackReadyFunction}
      />
    );
  };

  const ModelSog = () => {
    const queryParams = useQueryParams();
    const model = queryParams.get("model");
    const modelLink = queryParams.get("model");
    const app = useApp();
    const gsplatRef = useRef();
    const { asset, error } = useSplat(model);

    if (error) {
      console.error("Splat load error:", error);
      setErrorMessage(error);
    }
    useEffect(() => {
      if (!asset) {
        return;
      }
      const gsplatEntity = gsplatRef.current;
      if (!gsplatRef.current || !app) return;
      gsplatRef.current.gsplat.enabled = true;
      gsplatRef.current.gsplat.unified = true;
      gsplatRef.current.gsplat.asset = asset;

      gsplatRef.current.gsplat.customAabb = box;
      console.log(gsplatRef.current.gsplat.customAabb);
      setIsModelLoaded(true);

      if (latestCustomPathJsonData.current == null) {
        if (!modelLink) {
          return;
        }
        const pathJsonLink = modelLink.replace(".sog", "_customPath.json");
        fetchCustomPathData(pathJsonLink);
      } else {
        if (
          latestCustomPathJsonData.current.position &&
          latestCustomPathJsonData.current.rotation
        ) {
          setPositionEulerAngles(
            latestCustomPathJsonData.current.position[0][0],
            latestCustomPathJsonData.current.position[0][1],
            latestCustomPathJsonData.current.position[0][2],
            latestCustomPathJsonData.current.rotation[0][0],
            latestCustomPathJsonData.current.rotation[0][1],
            latestCustomPathJsonData.current.rotation[0][2],
          );
        }
      }

      gsplatEntity.addComponent("script");
      //createRadialScript(mainObjectEntityRef.current, gsplatEntity);
      // setTimeout(() => {
      //   cleanup(app, gsplatEntity);
      // }, 3500);
      // //resumeAutoPlay(3500);
      updateCameraData();
    }, [asset]);

    const box = new pc.BoundingBox(
      new pc.Vec3(0, 0, 0), // center
      new pc.Vec3(20, 20, 20), // half-extents
    );

    return (
      <Entity
        ref={gsplatRef}
        rotation={[180, 0, 0]}
        position={[0, 0, 0]}
        scale={[1, 1, 1]}
      >
        <GSplat />
      </Entity>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();
    const queryParams = useQueryParams();
    const modelLink = queryParams.get("model");

    if (modelLink.endsWith(".sog")) {
      splatFormat.current = "sog";
    } else if (modelLink.endsWith("_lod")) {
      splatFormat.current = "lod";
    }

    const isSog = modelLink.endsWith(".sog");
    const isLod = modelLink.endsWith("_lod");

    const newProgress = useRef(0);
    const handleUpdate = useCallback((dt: number) => {
      if (isAutoPlayingRef.current) {
        newProgress.current = latestProgressRef.current + 0.0005;
        newProgress.current = newProgress.current > 1 ? 1 : newProgress.current;
        setProgress(newProgress.current);
        if (newProgress.current == 1) {
          stopAutoPlay();
        }
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <>
        {/*{isSog ? <ModelSog /> : <></>}*/}
        {isSog ? <SingleSog /> : <></>}
        {isLod ? <SingleLod /> : <></>}
        <MainObject />
        <MainCamera />
      </>
    );
  };

  const Scene = () => {
    return (
      <Application>
        <PlaycanvasScene />
      </Application>
    );
  };

  const Loading = () => {
    const isModelLoaded = useModelViewerStore((state) => state.isModelLoaded);
    return !isModelLoaded ? (
      <div className="frosted-fullscreen flex flex-col items-center justify-center">
        <LottieLoading />
      </div>
    ) : (
      <></>
    );
  };

  const ErrorMessage = () => {
    const errorMessage = useModelViewerStore((state) => state.errorMessage);
    return errorMessage != "" ? (
      <div className="frosted-fullscreen flex flex-col items-center justify-center">
        {errorMessage}
      </div>
    ) : (
      <></>
    );
  };

  const setPositionEulerAngles = (
    positionX: number,
    positionY: number,
    positionZ: number,
    eulerAngleX: number,
    eulerAngleY: number,
    eulerAngleZ: number,
  ) => {
    console.log("@@@@@");
    console.log(positionX + " " + positionY + " " + positionZ);
    if (mainObjectEntityRef.current) {
      mainObjectEntityRef.current.setPosition(positionX, positionY, positionZ);
      mainObjectEntityRef.current.setLocalEulerAngles(
        eulerAngleX,
        eulerAngleY,
        eulerAngleZ,
      );
      isMovingRef.current = true;
      isRotatingRef.current = true;
    }
  };

  const fetchModelJsonData = async (link: string) => {
    try {
      const response = await fetch(link);
      if (!response.ok) throw new Error("Model Json Fetch failed");
      const jsonData = await response.json();
      latestModelJsonData.current = jsonData;

      if (jsonData.position && jsonData.target) {
        console.log(jsonData);
        setInitPositionTarget(
          jsonData.position.x,
          jsonData.position.y,
          jsonData.position.z,
          jsonData.target.x,
          jsonData.target.z,
          jsonData.target.z,
        );
      } else {
        setInitPositionTarget(0, 0, 0, 0, 0, 1);
      }
    } catch (err) {
      console.log("set 0,0,0 position");
      //setInitPositionAngle(0, 0, 0, 0, 0, 0, 0);
      setInitPositionTarget(0, 0, 0, 0, 0, 1);
    } finally {
    }
  };

  const fetchCustomPathData = async (url: string) => {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Path Json Fetch failed");
      const jsonData = await response.json();
      latestCustomPathJsonData.current = jsonData;
      if (Array.isArray(jsonData.positions)) {
        pathPosition.current = jsonData.positions;
      }
      if (Array.isArray(jsonData.rotations)) {
        pathRotation.current = jsonData.rotations;
      }
      const newPosition = pathPosition.current[0];
      const newRotation = pathRotation.current[0];
      //console.log(newPosition);
      setPositionEulerAngles(
        newPosition[0],
        newPosition[1],
        newPosition[2],
        newRotation[0],
        newRotation[1],
        newRotation[2],
      );
    } catch (error) {
      console.error("Failed to load new path data:", error);
    }
  };

  console.log(
    "Model Viewer Page component rendered , if this keep showing, something wrong",
  );

  const DragController = () => {
    const isDraggingRef = useRef(false);
    const startPosRef = useRef({ x: 0, y: 0 });
    const previousPositionRef = useRef({ x: 0, y: 0 });
    const getClientPos = (e) => {
      if (e.touches && e.touches.length > 0) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    };
    const handleStart = useCallback((e) => {
      const pos = getClientPos(e);
      isDraggingRef.current = true;
      previousPositionRef.current = { x: pos.x, y: pos.y };
    }, []);
    const handleMove = useCallback((e) => {
      if (!isDraggingRef.current) {
        return;
      }
      const pos = getClientPos(e);
      const xChange = pos.x - previousPositionRef.current.x;
      const yChange = pos.y - previousPositionRef.current.y;
      previousPositionRef.current = { x: pos.x, y: pos.y };
      latestRotationScreenData.current[0] = xChange * 0.5;
      latestRotationScreenData.current[1] = yChange * 0.5;
      interruptAutoPlay();
    }, []);
    const handleEnd = useCallback(() => {
      isDraggingRef.current = false;
      latestRotationScreenData.current[0] = 0;
      latestRotationScreenData.current[1] = 0;
    }, []);
    useEffect(() => {
      window.addEventListener("mouseup", handleEnd);
      window.addEventListener("touchend", handleEnd);
      return () => {
        window.removeEventListener("mouseup", handleEnd);
        window.removeEventListener("touchend", handleEnd);
      };
    }, []);

    return (
      <div
        className="fullscreen_div"
        onMouseDown={handleStart}
        onTouchStart={handleStart}
        onMouseMove={handleMove}
        onTouchMove={handleMove}
        onMouseUp={handleEnd}
        onTouchEnd={handleEnd}
      ></div>
    );
  };

  return (
    <div
      className="absolute top-0 left-0 w-full h-full"
      style={{ backgroundColor: "black" }}
    >
      <Loading />
      <ErrorMessage />
      <DataController />
      <Scene />
      <DragController />
      <WatermarkScreen />
    </div>
  );
}
